import React from "react";
import { Box, Button, Modal, Select, SimpleGrid } from "@mantine/core";

import { useForm } from "@mantine/form";
import { useDispatch, useSelector } from "react-redux";
import { setNoteType } from "../../store/reducers/note";
import useStyles from "./style";
import { noteTypesForUser } from "../../utils/noteTypeAccess";

const NoteTypeSelectModal = ({ opened, onclose, title, save }) => {
  const { classes } = useStyles();
  const { allNotesTypes } = useSelector((state) => state?.note);
  const { profile } = useSelector((state) => state?.profile);
  // Hide templates this staff member isn't included in (Studio → Availability).
  const noteTypes = noteTypesForUser(allNotesTypes?.ntypes, profile);
  const dispatch = useDispatch();

  const onSave = (values) => {
    dispatch(setNoteType(values?.selected));
  };
  const form = useForm({
    initialValues: {
      selected: "",
    },
    validate: {
      selected: (value) => (value ? null : "Please select type"),
    },
  });

  return (
    <Modal
      // size={""}
      onClose={() => {
        form?.reset();
        onclose();
      }}
      shadow="md"
      radius={"lg"}
      zIndex={1000}
      opened={opened}
      overlayProps={{ blur: 3 }}
      closeOnClickOutside={false}
      className={classes.mymodal}
      title={<b>{title}</b>}
      centered
      sx={{
        ".mantine-Modal-body": {
          backgroundColor: "WhiteSmoke !important",
          paddingBottom: "35px",
          height: "295px",
        },
      }}
    >
      <Box>
        <form>
          {/* Note Type in its own card, matching the create-note design */}
          <Box
            sx={{
              backgroundColor: "#ffffff",
              border: "1px solid var(--app-border, #E7E9EE)",
              borderRadius: "12px",
              boxShadow: "0 1px 2px rgba(16,24,40,.05)",
              padding: "15px 16px",
              position: "relative",
              top: "15px",
              zIndex: 1000,
            }}
          >
            <Select
              size="sm"
              searchable
              id="note-type"
              label="Note Type"
              placeholder="Select a note type…"
              className={`${classes.typeSelector}`}
              data={noteTypes?.map((value) => ({
                label: value?.name,
                value: value?.id,
              }))}
              {...form.getInputProps("selected")}
              onChange={(value) => {
                form.setFieldValue("selected", value);
                onSave({ selected: value });
              }}
            />
          </Box>

          {/* Empty-state helper shown until a note type is chosen */}
          {!form.values.selected ? (
            <Box
              sx={{
                marginTop: "30px",
                textAlign: "center",
                color: "var(--app-text-faint, #8A93A2)",
                fontSize: "13px",
                padding: "28px 20px",
                border: "1px dashed var(--app-border, #E7E9EE)",
                borderRadius: "12px",
                backgroundColor: "#ffffff",
              }}
            >
              Choose a note type above to start documenting.
            </Box>
          ) : null}

          {/* <SimpleGrid cols={2} m={"auto"} mt={25} mb={10}>
            <Button
              w={122}
              ml={"auto"}
              ff={"Inter"}
              color="yellow"
              onClick={onclose}
            >
              Cancel
            </Button>
            <Button
              w={122}
              mr={"auto"}
              ff={"Inter"}
              type="submit"
              color="yellow"
              id="note-add-button"
            >
              Add
            </Button>
          </SimpleGrid> */}
        </form>
      </Box>
    </Modal>
  );
};

export default NoteTypeSelectModal;
